import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CaseForm from "../components/CaseForm";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";

export default function EditCasePage({ kind }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const isAnte = kind === "ante_mortem";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const base = isAnte ? "/ante-mortem" : "/post-mortem";
    api.get(`${base}/${id}`)
      .then((r) => setData(r.data))
      .catch(() => {
        toast.error("Could not load this record.");
        navigate("/dashboard");
      })
      .finally(() => setLoading(false));
  }, [id, isAnte, navigate]);

  return (
    <div className="mx-auto max-w-3xl px-6 py-10" data-testid="edit-case-page">
      <p className="font-body text-xs uppercase tracking-[0.18em] text-[#6B7F82]">
        {isAnte ? t("dash.workspace.family") : t("dash.workspace.authority")}
      </p>
      <h1 className="mt-1 font-heading text-3xl font-semibold text-[#1A2024]">
        {isAnte ? t("edit.ante.title") : t("edit.post.title")}
      </h1>
      {data?.reference_code && (
        <p className="mt-1 font-mono text-xs text-[#6B7F82]" data-testid="edit-reference-code">{data.reference_code}</p>
      )}
      <p className="mt-2 max-w-2xl font-body text-sm text-[#5C6873]">
        {t("edit.sub")}
      </p>

      <div className="mt-8">
        {loading ? (
          <div className="font-body text-sm text-[#5C6873]" data-testid="edit-loading">{t("common.loading")}</div>
        ) : (
          <CaseForm
            kind={kind}
            caseId={id}
            initialData={data}
            onSubmit={() => {
              toast.success(t("form.submit.save"));
              navigate("/dashboard");
            }}
          />
        )}
      </div>
    </div>
  );
}
